<template>
  <v-container fluid class="pa-0">
    <v-row align="center" dense class="mt-n2 mb-2">
      <v-col cols="12" sm="6" md="7">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          hide-details
          label="Buscar usuario..."
          v-model="search"
          class="white rounded-lg"
        >
        </v-text-field>
      </v-col>
      <v-col v-if="distributorSelected" cols="12" sm="6" md="5" class="text-end d-flex justify-end align-center" :class="{ 'd-none': $vuetify.breakpoint.xsOnly }">
        <v-btn color="primary" @click="showAddUserModal = true" rounded small elevation="0" class="mr-2">
          <v-icon left size="18"> mdi-account-plus-outline </v-icon>
          Usuario
        </v-btn>
        
        <!-- Desktop Filter Menu -->
        <v-menu
          offset-y
          :close-on-click="false"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0">
              <v-icon left size="18">mdi-filter</v-icon>
              Filtro
            </v-btn>
          </template>
          <v-card width="350px">
            <v-card-text class="pt-4">
              <v-container>
                <v-row>
                  <v-col cols="12" class="px-0 py-0">
                    <span class="font-weight-bold">Zona</span>
                    <v-divider class="my-2"></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      label="Selecciona zona"
                      :items="zones"
                      clearable
                      hide-details
                      hide-no-data
                      dense
                      outlined
                      v-model="zoneSelected"
                      return-object
                      item-text="name"
                      :search-input.sync="zoneSearch"
                      class="white rounded-lg"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="clearFilters" text>Restaurar</v-btn>
              <v-btn color="primary" @click="fetchUsers" rounded>Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>

    <!-- Mobile Action Buttons & Filter -->
    <v-row v-if="$vuetify.breakpoint.xsOnly && distributorSelected" class="px-3 pb-3 mt-n4 mb-n2">
      <v-col class="pa-0 text-right">
        <!-- Filter Bottom Sheet for Mobile -->
        <v-dialog
          v-model="mobileFilterDialog"
          transition="dialog-bottom-transition"
          fullscreen
          hide-overlay
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0" class="mr-2">
              <v-icon left size="18">mdi-filter</v-icon> Filtro
            </v-btn>
          </template>
          <v-card class="d-flex flex-column h-100 rounded-0">
            <v-toolbar color="primary" dark fixed-header elevation="0">
              <v-toolbar-title>Filtros de Usuarios</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="mobileFilterDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pt-6 flex-grow-1 overflow-y-auto">
              <span class="font-weight-bold">Zona</span>
              <v-divider class="my-2 mb-4"></v-divider>
              <v-autocomplete
                label="Selecciona zona"
                :items="zones"
                clearable
                hide-details
                hide-no-data
                dense
                outlined
                v-model="zoneSelected"
                return-object
                item-text="name"
                :search-input.sync="zoneSearch"
                class="white rounded-lg"
              ></v-autocomplete>
            </v-card-text>
            
            <div class="sticky-footer white pa-4 elevation-10">
              <v-row dense>
                <v-col cols="6">
                  <v-btn color="warning" block text @click="clearFilters">Restaurar</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn color="primary" block rounded @click="fetchUsers(); mobileFilterDialog = false;">
                    Aplicar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    
    <!-- Mobile Floating Action Button (FAB) -->
    <v-btn
      v-if="$vuetify.breakpoint.xsOnly && distributorSelected"
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      style="bottom: 80px; right: 16px; z-index: 5;"
      @click="showAddUserModal = true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-row class="mt-n4">
      <v-col>
        <template v-if="$vuetify.breakpoint.xsOnly">
          <v-container class="pa-2 px-0 bg-app">
            <v-row dense>
              <v-col
                cols="12"
                v-for="item in users"
                :key="item._id"
                class="mb-2"
              >
                <v-card elevation="1" class="rounded-xl pa-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="d-flex align-center">
                      <v-avatar color="primary" size="40" class="mr-3">
                        <span class="white--text text-subtitle-1 font-weight-bold">
                          {{ item.name.charAt(0) }}
                        </span>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-bold grey--text text--darken-4 line-height-tight">
                          {{ item.name }} {{ item.lastName }}
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                          {{ item.email }}
                        </div>
                      </div>
                    </div>
                    <v-menu :rounded="true" offset-y left>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn icon v-bind="attrs" v-on="on" small color="grey darken-1">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list v-if="item.isExpire">
                        <v-list-item @click="activeUser(item)">
                          <v-list-item-title>Activar</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <v-list v-else>
                        <v-list-item @click="updateModal(item)">
                          <v-list-item-title>Actualizar</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="suspendUser(item)">
                          <v-list-item-title class="error--text">Suspender</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>

                  <v-divider class="my-2"></v-divider>

                  <v-row dense class="text-caption">
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Rol</div>
                      <div class="font-weight-medium text-truncate">
                        <span v-if="item.role == 'SELLER'">Asesor</span>
                        <span v-else-if="item.role == 'ADMIN_SAMPLER'">Admin</span>
                        <span v-else-if="item.role == 'SAMPLER_SOLENA'">Asesor Solena</span>
                        <span v-else-if="item.role == 'GEN_MANAGER'">Gerente distribuidor</span>
                        <span v-else-if="item.role == 'MANAGER'">Gerente zona</span>
                        <span v-else-if="item.role == 'ADVISOR'">Asesor</span>
                        <span v-else-if="item.role == 'ORG_USER'">Cliente</span>
                        <span v-else-if="item.role == 'ORG_USER_ADMIN'">Cliente Admin</span>
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Estado</div>
                      <v-chip
                        small
                        :color="item.isExpire ? 'error' : 'success'"
                        :text-color="'white'"
                        class="font-weight-bold px-2"
                        style="height: 20px;"
                      >
                        <span v-if="item.isExpire"> Suspendido </span>
                        <span v-else> Activo </span>
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Teléfono</div>
                      <div class="font-weight-medium">
                        <span v-if="!item.phone || item.phone.length == 0"> No especificado </span>
                        <span v-else> {{ item.phone }} </span>
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Zona</div>
                      <div class="font-weight-medium text-truncate" v-if="item.zone">
                        {{ item.zone.name }}
                      </div>
                      <div class="font-weight-medium grey--text" v-else>
                        Sin zona
                      </div>
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <div class="grey--text">Dirección</div>
                      <div class="font-weight-medium">
                        <span v-if="!item.address"> No especificada </span>
                        <span v-else> {{ item.address }} </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-data-table
          v-else
          width="100%"
          :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 400px)`"
          :headers="headers"
          :items="users"
          fixed-header
          :items-per-page="5"
          class="elevation-1"
          no-data-text="No hay usuarios registrados o que coincidan con la búsqueda"
          loading-text="Cargando usuarios..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
        >
          <template v-slot:item.name="{ item }">
            <div class="d-flex align-center py-2">
              <v-avatar color="primary" size="36" class="mr-3">
                <span class="white--text text-caption font-weight-bold">
                  {{ item.name.charAt(0) }}
                </span>
              </v-avatar>
              <div>
                <div class="font-weight-bold grey--text text--darken-4 line-height-tight">
                  {{ item.name }} {{ item.lastName }}
                </div>
                <div class="text-caption grey--text text--darken-1">
                  {{ item.email }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.role="{ item }">
            <span v-if="item.role == 'SELLER'">Asesor</span>
            <span v-else-if="item.role == 'ADMIN_SAMPLER'">Admin</span>
            <span v-else-if="item.role == 'SAMPLER_SOLENA'">Asesor Solena</span>
            <span v-else-if="item.role == 'GEN_MANAGER'">Gerente distribuidor</span>
            <span v-else-if="item.role == 'MANAGER'">Gerente zona</span>
            <span v-else-if="item.role == 'ADVISOR'">Asesor</span>
            <span v-else-if="item.role == 'ORG_USER'">Cliente</span>
            <span v-else-if="item.role == 'ORG_USER_ADMIN'">Cliente Admin</span>
          </template>
          <template v-slot:item.phone="{ item }">
            <span class="grey--text text--darken-2" v-if="!item.phone || item.phone.length == 0">
              No especificado
            </span>
            <span v-else> {{ item.phone }} </span>
          </template>
          <template v-slot:item.zone="{ item }">
            <span class="font-weight-medium" v-if="item.zone"> {{ item.zone.name }} </span>
            <span class="grey--text text--darken-1" v-else> Sin zona </span>
          </template>
          <template v-slot:item.address="{ item }">
            <span class="grey--text text--darken-2" v-if="!item.address">No especificada</span>
            <span v-else>{{ item.address }}</span>
          </template>
          <template v-slot:item.isExpire="{ item }">
            <v-chip
              small
              :color="item.isExpire ? 'error' : 'success'"
              :text-color="'white'"
              class="font-weight-bold px-3"
            >
              <span v-if="item.isExpire"> Suspendido </span>
              <span v-else> Activo </span>
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu :rounded="true" offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn class="ma-0" v-bind="attrs" v-on="on" icon small>
                  <v-icon color="grey darken-1"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list v-if="item.isExpire">
                <v-list-item @click="activeUser(item)">
                  <v-list-item-title>Activar </v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item @click="updateModal(item)">
                  <v-list-item-title> Actualizar </v-list-item-title>
                </v-list-item>
                <v-list-item @click="suspendUser(item)">
                  <v-list-item-title>Suspender </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
          class="mt-n2"
        ></v-pagination>
      </v-col>
    </v-row>
    <AddUserModal
      v-model="showAddUserModal"
      v-if="showAddUserModal"
      @fetchData="fetchUsers()"
    />
    <UpdateUser
      v-model="showUpdateUser"
      v-if="showUpdateUser"
      @fetchData="fetchUsers()"
    />
    <SuspendModal
      v-model="showSuspendModal"
      v-if="showSuspendModal"
      @fetchData="fetchUsers()"
    />
    <ActiveModal
      v-model="showActiveModal"
      v-if="showActiveModal"
      @fetchData="fetchUsers()"
    />
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//components
import AddUserModal from "@/components/users/modals/AddUser.vue";
import UpdateUser from "@/components/users/modals/UpdateUser.vue";
import SuspendModal from "@/components/users/modals/SuspendModal.vue";
import ActiveModal from "@/components/users/modals/ActiveModal.vue";
export default {
  components: {
    AddUserModal,
    UpdateUser,
    SuspendModal,
    ActiveModal,
  },
  data: () => ({
    tabs: 0,

    users: [],
    page: 1,
    numPages: 0,
    fetchingData: false,
    search: null,
    showAddUserModal: false,
    showUpdateUser: false,
    showSuspendModal: false,
    showActiveModal: false,
    zoneSearch: null,
    mobileFilterDialog: false,
    zoneSelected: null,
  }),
  computed: {
    ...mapState("user", ["distributorSelected"]),
    headers() {
      return [
        { text: "Usuario", align: "start", sortable: false, value: "name" },
        { text: "Rol", sortable: false, value: "role" },
        { text: "Teléfono", sortable: false, value: "phone" },
        { text: "Zona", sortable: false, value: "zone" },
        { text: "Dirección", sortable: false, value: "address" },
        { text: "Estatus", sortable: false, value: "isExpire" },
        { text: "Acciones", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("user", ["SET_USER_TO_UPDATE"]),
    ...mapActions("user", ["getUsersByDistributor"]),
    ...mapActions("zone", ["getZonesByDistributorPaged"]),
    showAllAddress(address) {},
    updateModal(user) {
      this.SET_USER_TO_UPDATE(user);
      this.showUpdateUser = true;
    },
    suspendUser(user) {
      this.SET_USER_TO_UPDATE(user);
      this.showSuspendModal = true;
    },
    activeUser(user) {
      this.SET_USER_TO_UPDATE(user);
      this.showActiveModal = true;
    },
    async clearFilters() {
      this.zoneSearch = null;
      this.zoneSelected = null;
      await this.fetchUsers();
    },
    async fetchUsers() {
      try {
        this.fetchingData = true;
        let payload = {
          distributorId: this.distributorSelected
            ? this.distributorSelected._id
            : null,
          page: this.page,
          search: this.search,
          zone: this.zoneSelected ? this.zoneSelected._id : null,
        };
        let response = await this.getUsersByDistributor(payload);
        if (!response) throw response;
        this.users = response.users;
        this.numPages = response.pages;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar usuarios",
          timeout: 5000,
        });
      }
      this.fetchingData = false;
    },
  },
  async created() {
    await this.fetchUsers();
  },
  watch: {
    async distributorSelected() {
      await this.fetchUsers();
    },
    async search() {
      this.page = 1;
      this.numPages = 1;
      await this.fetchUsers();
    },
    async page() {
      await this.fetchUsers();
    },
    async zoneSearch(value) {
      if (!value) return;
      try {
        let payload = {
          distributorId: this.distributorSelected
            ? this.distributorSelected._id
            : null,
          page: 1,
          search: value,
        };
        let response = await this.getZonesByDistributorPaged(payload);
        if (!response) throw response;
        this.zones = response.zones;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar zonas",
          timeout: 5000,
        });
      }
    },
  },
};
</script>

<style scoped></style>
